<template>
  <v-app style="height: 100vh; width: 100vw; overflow: hidden">
    <v-main>
      <v-container
        fill-height
        fluid
        class="d-flex justify-center align-center ma-0 pa-0"
        style="width: 100vw; height: 100vh; overflow: hidden"
      >
        <div
          v-if="url && token"
          id="vizContainer"
          class="ma-0 pa-0"
          style="width: 100%; height: 100%"
        ></div>
        <v-img v-else max-width="500px" src="@/assets/logo.jpg" />
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { callTableauApi } from "./fns";

export default {
  name: "App",
  data() {
    return {
      media: {},
      url: "",
      token: "",
      viz: null, // Store the Tableau Viz instance
    };
  },
  async mounted() {
    window.loadData = this.loadData;
    //window.name = ``;
    // window.name = `{"brand": "ftxap",
    //     "email": "issa@beetek.com.au",
    //     "id": "8HHntsqIbdr57rzcdg4Q"}`;
    // console.log("window.name", window.name);
    if (window.name) {
      const data = JSON.parse(window.name);
      if (data) this.loadData(data);
    }
    window.addEventListener(
      "message",
      (event) => {
        eval(event.data);
      },
      false
    );
  },
  methods: {
    async getData() {
      const data = await callTableauApi(this.media);
      this.url = data.url;
      this.token = data.token;
    },
    async loadData(media) {
      this.media = typeof media === "object" ? media : JSON.parse(media);
      await this.getData();
      this.initViz();
    },
    initViz() {
      this.viz = new window.TableauViz();
      this.viz.src = this.url;
      this.viz.width = window.innerWidth;
      this.viz.hideTabs = true;
      if (this.token && this.token != "NA") this.viz.token = this.token;
      this.viz.setFrameSize(window.innerWidth, window.innerHeight);
      document.getElementById("vizContainer").appendChild(this.viz);
    },
  },
};
</script>

<style></style>
